<template>
  <v-app>
    <Alert />
    <Dialog />
    <vertical-nav-menu
      :is-drawer-open.sync="isDrawerOpen"
      v-on:login="login()"
      v-on:logout="logout()"
    ></vertical-nav-menu>

    <v-app-bar app flat absolute color="transparent">
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon
            class="d-block d-lg-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>

          <v-spacer></v-spacer>

          <!-- Right Content -->
          <a
            href="https://gitlab.com/m.shidqi810/final-project-sanber-vue"
            target="_blank"
            rel="nofollow"
          >
            <v-icon class="ms-6 me-4">
              {{ icons.mdiGithub }}
            </v-icon>
          </a>
          <theme-switcher></theme-switcher>
          <app-bar-user-menu
            v-if="!guest"
            v-on:logout="logout()"
          ></app-bar-user-menu>
          <v-spacer></v-spacer>
          <v-btn
            v-if="guest"
            color="primary"
            class="ms-12 me-4"
            @click="login()"
            ><v-icon left>mdi-lock</v-icon> Login
          </v-btn>
          <v-btn
            v-if="guest"
            color="success"
            class="ms-2 me-4"
            @click="register()"
            ><v-icon left>mdi-account</v-icon> Register
          </v-btn>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">
        <slot></slot>
      </div>
    </v-main>

    <v-footer app inset color="transparent" absolute height="56" class="px-0">
      <div class="boxed-container w-full">
        <div class="mx-6 d-flex justify-space-between">
          <span>
            &copy; 2021
            <a
              href="/about"
              target="_blank"
              rel="nofollow"
              class="text-decoration-none"
              >TUBES Kelompok 1
            </a>
          </span>
        </div>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import { ref } from "@vue/composition-api";
import { mdiMagnify, mdiBellOutline, mdiGithub } from "@mdi/js";
import VerticalNavMenu from "./components/vertical-nav-menu/VerticalNavMenu.vue";
import ThemeSwitcher from "./components/ThemeSwitcher.vue";
import AppBarUserMenu from "./components/AppBarUserMenu.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
    Alert: () => import("./components/Alert"),
    Dialog: () => import("./components/Dialog.vue"),
  },
  data: () => ({
    drawer: false,
    menus: [
      { title: "home", icon: "mdi-home", route: "/" },
      { title: "blogs", icon: "mdi-note", route: "/blogs" },
    ],
    apiDomain: "https://demo-api-vue.sanbercloud.com",
    snackbarStatus: true,
    snackbarText: "Anda berhasil menampilkan alert",
  }),
  computed: {
    ...mapGetters({
      guest: "auth/guest",
      user: "auth/user",
      token: "auth/token",
    }),
  },
  mounted() {
    this.snackbarStatus = true;
    if (this.token) {
      this.checkToken(this.token);
    }
  },
  setup() {
    const isDrawerOpen = ref(null);

    return {
      isDrawerOpen,

      // Icons
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
      },
    };
  },
  methods: {
    logout() {
      let config = {
        method: "post",
        url: this.apiDomain + "/api/v2/auth/logout",
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };

      this.axios(config)
        .then(() => {
          this.setToken(""),
            this.setUser({}),
            this.setAlert({
              status: true,
              color: "success",
              text: "Anda berhasil Logout",
            });
        })

        .catch((responses) => {
          this.setAlert({
            status: true,
            color: "error",
            text: responses.data.error,
          });
        });
    },
    login() {
      this.setDialogStatus(true);
      this.setDialogComponent({ component: "login" });
    },
    register() {
      this.setDialogStatus(true);
      this.setDialogComponent({ component: "register" });
    },
    ...mapActions({
      setAlert: "alert/set",
      setDialogComponent: "dialog/setComponent",
      setDialogStatus: "dialog/setStatus",
      setToken: "auth/setToken",
      setUser: "auth/setUser",
      checkToken: "auth/checkToken",
    }),
  },
};
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}
</style>
